import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ListItemIcon, ListItemText, MenuItem } from '@material-ui/core';
import { Beenhere } from '@material-ui/icons';
import { CentralProviderContext } from '../../../centralProviderContext/CentralProviderContext';
import { centralPublicURL } from '../../../environment.vars';
export function UserProfile(_a) {
    var closeDropdown = _a.closeDropdown;
    var contextValue = useContext(CentralProviderContext);
    var t = useTranslation().t;
    var centralURL = centralPublicURL;
    var handleClick = function () {
        var _a, _b;
        var element = document.createElement('a');
        // eslint-disable-next-line max-len
        var link = "".concat(centralURL, "/").concat((_b = (_a = contextValue.selectedGrant) === null || _a === void 0 ? void 0 : _a.accounts[0]) === null || _b === void 0 ? void 0 : _b.customer_number, "/admin/user-profile-form/").concat((contextValue.centralProfile).uid, "?language=").concat(contextValue.currentLanguage);
        element.href = link;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
        closeDropdown();
        try {
            element.remove();
        }
        catch (e) {
            element.href = '#';
        }
    };
    return (React.createElement(MenuItem, { onClick: handleClick },
        React.createElement(ListItemIcon, { style: { minWidth: '33px' } },
            React.createElement(Beenhere, { color: "primary" })),
        React.createElement(ListItemText, { primary: t('User Profile') })));
}
//# sourceMappingURL=UserProfile.js.map